import getToken, { setToken } from '../auth/token';
import { baseUrl } from '../config';
const ajaxConfig = {
    baseUrl: baseUrl,
};
export const prepareUrl = (url) => {
    if (url.startsWith('/')) {
        return ajaxConfig.baseUrl + url;
    }
    return url;
};
const jsonReplacer = (key, value) => {
    if (typeof value === 'object' && value instanceof Set) {
        return Array.from(value);
    }
    return value;
};
const makeRequest = (method, url, successCallback, errorCallback, data = undefined) => {
    const xhr = new XMLHttpRequest();
    const listener = () => {
        if (xhr.readyState === 4) {
            const newToken = xhr.getResponseHeader('token');
            if (newToken) {
                setToken(newToken);
            }
            if (xhr.status === 200) {
                if (successCallback) {
                    successCallback(JSON.parse(xhr.responseText), xhr);
                }
            }
            else {
                if (errorCallback) {
                    errorCallback(xhr.statusText, xhr.status, xhr);
                }
            }
        }
    };
    xhr.open(method, prepareUrl(url));
    if (null !== getToken()) {
        xhr.setRequestHeader('Authorization', 'Bearer ' + getToken());
    }
    let json = null;
    if (undefined !== data) {
        json = JSON.stringify(data, jsonReplacer);
        xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    }
    xhr.addEventListener('readystatechange', listener);
    xhr.send(json);
    const cancel = () => {
        xhr.removeEventListener('readystatechange', listener);
        xhr.abort();
    };
    return { xhr: xhr, cancel: cancel };
};
const ajax = {
    get: (url, successCallback, errorCallback) => {
        return makeRequest('GET', url, successCallback, errorCallback);
    },
    post: (url, data, successCallback, errorCallback) => {
        return makeRequest('POST', url, successCallback, errorCallback, data);
    },
    put: (url, data, successCallback = null, errorCallback = null) => {
        return makeRequest('PUT', url, successCallback, errorCallback, data);
    },
    putFile: (url, file, data = {}, successCallback = null, errorCallback = null) => {
        const realUrl = prepareUrl(url);
        const xhr = new XMLHttpRequest();
        const fd = new FormData();
        xhr.open("PUT", realUrl, true);
        if (null !== getToken()) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + getToken());
        }
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                const newToken = xhr.getResponseHeader('token');
                if (newToken) {
                    setToken(newToken);
                }
                if (xhr.status === 200) {
                    if (successCallback) {
                        successCallback(JSON.parse(xhr.responseText), xhr);
                    }
                }
                else {
                    if (errorCallback) {
                        errorCallback(xhr.statusText, xhr.status, xhr);
                    }
                }
            }
        };
        fd.append('myFile', file);
        Object.entries(data).forEach((entry) => {
            fd.set(entry[0], entry[1]);
        });
        xhr.send(fd);
    },
    patch: (url, data, successCallback = null, errorCallback = null) => {
        return makeRequest('PATCH', url, successCallback, errorCallback, data);
    },
    delete: (url, successCallback = null, errorCallback = null, data = {}) => {
        return makeRequest('DELETE', url, successCallback, errorCallback, data);
    }
};
export default ajax;
